const callbacks = {};

export default class EventsService {
	/**
	 * @param {string} eventName name of event
	 * @param {Function} callback
	 */
	static listenEvent(eventName, id, callback) {
		if (!callbacks[eventName]) {
			callbacks[eventName] = {};
		}

		callbacks[eventName][id] = callback;
	}

	/**
	 * @param {string} eventName
	 * @param {*} data
	 */
	static triggerEvent(eventName, data = null) {
		if (callbacks[eventName]) {
			Object.keys(callbacks[eventName]).forEach(id => {
				callbacks[eventName][id](data);
			});
		}
	}

	/**
	 * @param {string} eventName name of event
	 * @param {string} id callback identifier
	 */
	static unlistenEvent(eventName) {
		delete callbacks[eventName];
	}
}
